import { render, staticRenderFns } from "./edit-show.vue?vue&type=template&id=ed5a9afe&scoped=true&"
import script from "./edit-show.vue?vue&type=script&lang=js&"
export * from "./edit-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5a9afe",
  null
  
)

export default component.exports